<div mat-dialog-title>
  <h2>{{ title }}</h2>
</div>

<mat-progress-bar mode="determinate"></mat-progress-bar>

<form [formGroup]="productData" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="10px grid">
      <div fxLayout="row">
        <mat-form-field appearance="fill" fxFlex>
          <mat-label>CPT Code</mat-label>
          <mat-select formControlName="code">
            <mat-option
              *ngFor="let code of productCodes"
              [value]="code"
            >
              {{ code }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-form-field appearance="fill" fxFlex="40">
          <mat-label>PriceModel</mat-label>
          <input
            matInput
            type="number"
            placeholder="1000.00"
            name="price"
            formControlName="price"
          />
          <mat-error *ngIf="productData.controls['price'].invalid">{{
            getErrorMessage('price')
          }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" fxFlex>
          <mat-label>Currency</mat-label>
          <mat-select formControlName="priceCurrency">
            <mat-option
              *ngFor="let currency of currencies"
              [value]="currency.value"
            >
              {{ currency.viewValue }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="productData.controls.priceCurrency.invalid">
            {{ getErrorMessage('priceCurrency') }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex>
        <p class="mb-0 mt-1"><strong>Requirements</strong></p>
        <p>
          Use the options below to specify requirements for this price. The
          price will only apply if every requirement is met.
        </p>
      </div>

      <mat-form-field appearance="fill" fxFlex>
        <mat-label>Carriers</mat-label>
        <mmx-carrier-lookups-selector-input
          formControlName="carriers"
        ></mmx-carrier-lookups-selector-input>
      </mat-form-field>
    </div>
    <mat-error *ngFor="let err of errors">{{ err?.message }}</mat-error>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-stroked-button type="button" mat-dialog-close>Cancel</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button
      mat-flat-button
      [disabled]="productData.invalid"
      color="primary"
      type="submit"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
